import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import UISection from 'UIComponents/section/UISection';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import styled, { useMediaQuery } from '../../../utils/Styling'; // @ts-expect-error Could not find a declaration file for module

import { useLocationWithoutParams } from '../../../hooks/searchParamHooks';
import RouterDropdownFilter, { RouterFilterTags, RouterSearchInput, ClearFiltersLink, StyledTagsContainer, RouterSelectSingle // @ts-expect-error Could not find a declaration file for module
} from '../../../containers/TracksPage/RouterDropdownFilter';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
const FilterContainer = styled(UISection).withConfig({
  displayName: "TopFilters__FilterContainer",
  componentId: "vobqir-0"
})(["position:relative;margin-left:-12px;margin-top:-20px !important;margin-bottom:4px !important;"]);
const FilterPositionedSearchInput = styled(RouterSearchInput).withConfig({
  displayName: "TopFilters__FilterPositionedSearchInput",
  componentId: "vobqir-1"
})(["margin-bottom:10px;"]);
const NoFilterPositionedSearchInput = styled(RouterSearchInput).withConfig({
  displayName: "TopFilters__NoFilterPositionedSearchInput",
  componentId: "vobqir-2"
})(["margin-top:12px;margin-bottom:20px;"]);

const useSearchFilter = enabledFilters => {
  if (enabledFilters.includes(FILTER_TYPES.SEARCH)) return FILTER_TYPES.SEARCH;
  if (enabledFilters.includes(FILTER_TYPES.SEARCH_USER)) return FILTER_TYPES.SEARCH_USER;
  if (enabledFilters.includes(FILTER_TYPES.SEARCH_TEAMS)) return FILTER_TYPES.SEARCH_TEAMS;
  return null;
};

const TopFilters = ({
  enabledFilters,
  showClearButton = true,
  showLabel = true,
  showTags = true
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const [hasFilters] = useLocationWithoutParams(enabledFilters);
  const searchFilter = useSearchFilter(enabledFilters);

  const isSearchFilter = filter => [FILTER_TYPES.SEARCH, FILTER_TYPES.SEARCH_USER, FILTER_TYPES.SEARCH_TEAMS].includes(filter);

  return isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FilterContainer, {
      children: /*#__PURE__*/_jsxs(StyledTagsContainer, {
        children: [enabledFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
          filterType: filter
        }, filter)), showClearButton && /*#__PURE__*/_jsx(ClearFiltersLink, {
          filtersToClear: enabledFilters
        })]
      })
    }), searchFilter ? hasFilters ? /*#__PURE__*/_jsx(FilterPositionedSearchInput, {
      className: "search-input",
      filterType: searchFilter
    }) : /*#__PURE__*/_jsx(NoFilterPositionedSearchInput, {
      className: "search-input",
      filterType: searchFilter
    }) : null]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFilterBar, {
      className: "top-filters-bar",
      endSlot: searchFilter && /*#__PURE__*/_jsx(RouterSearchInput, {
        filterType: searchFilter
      }),
      startSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [showLabel && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), enabledFilters.map(filter => {
          if (isSearchFilter(filter)) return null;

          switch (filter) {
            case FILTER_TYPES.ASSIGNED_BY:
              return /*#__PURE__*/_jsx(UIInlineLabel, {
                label: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `learningCenter.topFilters.${filter}.filterTitle`
                }),
                children: /*#__PURE__*/_jsx(RouterSelectSingle, {
                  filterType: filter
                })
              });

            case FILTER_TYPES.CREATED_BY:
            case FILTER_TYPES.LANGUAGE:
              return /*#__PURE__*/_jsx(RouterSelectSingle, {
                filterType: filter,
                retainSelection: false,
                valueRenderer: () => /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `learningCenter.topFilters.${filter}.filterTitle`
                })
              });

            default:
              return /*#__PURE__*/_jsx(RouterDropdownFilter, {
                filterType: filter
              }, `top-filter-${filter}`);
          }
        })]
      })
    }), /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsxs(StyledTagsContainer, {
        children: [showTags && enabledFilters.map(filter => !isSearchFilter(filter) && /*#__PURE__*/_jsx(RouterFilterTags, {
          filterType: filter
        }, filter)), showClearButton && /*#__PURE__*/_jsx(ClearFiltersLink, {
          filtersToClear: enabledFilters
        })]
      })
    })]
  });
};

export default TopFilters;